var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('time',{staticClass:"app-time-ago",class:{ small: _vm.small },attrs:{"datetime":_vm.value,"auto-update":_vm.updateInterval}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }